import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=2a398698&scoped=true"
import script from "./SupportList.vue?vue&type=script&lang=js"
export * from "./SupportList.vue?vue&type=script&lang=js"
import style0 from "./SupportList.vue?vue&type=style&index=0&id=2a398698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a398698",
  null
  
)

export default component.exports